"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var MirrorVertical = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M9,7.00798298 L16.015966,7.00798298 C16.5574815,7.00798298 17.007983,6.55564244 17.007983,6.00206393 L17.007983,3.01390204 C17.007983,2.45013772 16.567143,2.00798298 16.015966,2.00798298 L9,2.00798298 C8.4584845,2.00798298 8.00798298,2.46032352 8.00798298,3.01390204 L8.00798298,6.00206393 C8.00798298,6.56582825 8.44882302,7.00798298 9,7.00798298 Z M9,8.00798298 C7.89983938,8.00798298 7.00798298,7.12142815 7.00798298,6.00206393 L7.00798298,3.01390204 C7.00798298,1.90606354 7.90815915,1.00798298 9,1.00798298 L16.015966,1.00798298 C17.1161266,1.00798298 18.007983,1.89453782 18.007983,3.01390204 L18.007983,6.00206393 C18.007983,7.10990243 17.1078068,8.00798298 16.015966,8.00798298 L9,8.00798298 Z M8.99201702,23.0059191 C7.8918564,23.0059191 7,22.1193642 7,21 L7,18.0118381 C7,16.9039996 7.90017617,16.0059191 8.99201702,16.0059191 L16.007983,16.0059191 C17.1081436,16.0059191 18,16.8924739 18,18.0118381 L18,21 C18,22.1078385 17.0998238,23.0059191 16.007983,23.0059191 L8.99201702,23.0059191 Z M2,12.5 L2,11.5 L22,11.5 L22,12.5 L2,12.5 Z" })));
};
MirrorVertical.displayName = 'MirrorVertical';
exports.default = MirrorVertical;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=MirrorVertical.js.map